import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Pagination, Space, Table, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DeleteApprovalApi from "../../api/approvals/DeleteApprovalApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import ApproveDesignationModal from "../modal/ApproveDesignationModal";

import ApprovePlanModal from "../modal/ApprovePlanModal";
import ApproveUnitModal from "../modal/ApproveUnitModal";
import ApproveUserModal from "../modal/ApproveUserModal";
import ConfirmationModal from "../modal/ConfirmationModal";
import EditApproverModal from "../modal/edit/EditApproverModal";
import PageLoader from "../sub/PageLoader";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function AllApprovalsTable(props) {
  const [rejectModal, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [unitInfo, setUnitInfo] = useState(false);
  const [planInfo, setPlanInfo] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [designationInfo, setDesignationInfo] = useState(false);
  const [approvalId, setApprovalId] = useState("");
  const [approvalAction, setApprovalAction] = useState("");
  const [data, setData] = useState("");
  const [currentApprover, setCurrentApprover] = useState("");
  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.tableLoading);
  }, [props.tableLoading]);

  function openInfoModal(type) {
    if (type === "Unit") {
      setUnitInfo(true);
    } else if (type === "User") {
      setUserInfo(true);
    } else if (type === "Plan") {
      setPlanInfo(true);
    } else if (type === "Designation") {
      setDesignationInfo(true);
    }
  }
  function getStatusColor(status) {
    let color = "";
    if (status === "Pending") {
      color = "orange";
    } else if (status === "Approved") {
      color = "green";
    } else {
      color = "red";
    }
    return color;
  }

  async function deleteApproval() {
    setLoading(true);
    const apiResponse = await DeleteApprovalApi(approvalId);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (props.data?.approvals?.length === 1) {
        props.changePage(
          props.current === 1 ? props.current : props.current - 1
        );
      } else {
        props.changePage(props.current);
      }
    } else {
      openNotificationError("bottomRight", "Couldn't delete. Try again later.");
    }
    setApprovalId("");
    setLoading(false);
  }

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      render: (text, record) => <div>{text}</div>,
    },
    {
      title:
        positionState?.userRole?.name === "Manager" ? "Approver" : "Added by",
      dataIndex: "addedBy",
      key: "addedBy",
      render: (text, record) => (
        <div>
          {positionState?.userRole?.name === "Manager" ? (
            <div>
              {record.approvedBy?.user?.firstName}{" "}
              <Tooltip title={"Edit"}>
                <div
                  onClick={() => {
                    setEditModal(true);
                    setApprovalId(record.id);
                    setCurrentApprover(record.approvedBy?.user?.firstName);
                  }}
                  className="text-blue-500 hover:text-blue-600 inline cursor-pointer"
                >
                  <EditOutlined />
                </div>
              </Tooltip>
            </div>
          ) : (
            record.requestBy?.user?.firstName
          )}
        </div>
      ),
    },
    {
      title: "Added on",
      dataIndex: "addedOn",
      key: "addedOn",
      render: (text, record) => <div>{record.createdOn?.slice(0, 10)}</div>,
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (text) => (
        <Tag color={getStatusColor(text)}>{text?.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title={"Info"}>
            <div
              onClick={() => {
                openInfoModal(record.type);
                setData(record);
                setApprovalId(record.id);
              }}
              className="text-blue-500 hover:text-blue-600 cursor-pointer"
            >
              <InfoCircleOutlined />
            </div>
          </Tooltip>

          {positionState?.userRole?.name !== "Manager"
            ? record.status === "Pending" && (
                <>
                  <Tooltip title={"Approve"}>
                    <div
                      onClick={() => {
                        setApproveModal(true);
                        setApprovalId(record.id);
                        setApprovalAction("Approved");
                      }}
                      className="text-green-500 hover:text-green-600 cursor-pointer"
                    >
                      <CheckCircleOutlined />
                    </div>
                  </Tooltip>
                  <Tooltip title={"Reject"}>
                    <div
                      onClick={() => {
                        setRejectModal(true);
                        setApprovalId(record.id);
                        setApprovalAction("Rejected");
                      }}
                      className="text-red-500 hover:text-red-600 cursor-pointer"
                    >
                      <CloseCircleOutlined />
                    </div>
                  </Tooltip>
                </>
              )
            : record.status === "Pending" && (
                <Tooltip title={"Delete"}>
                  <div
                    onClick={() => {
                      setDeleteModal(true);
                      setApprovalId(record.id);
                    }}
                    className="text-red-500 hover:text-red-600 cursor-pointer"
                  >
                    <DeleteOutlined />
                  </div>
                </Tooltip>
              )}
        </Space>
      ),
    },
  ];
  return (
    <>
      <>
        <Table
          pagination={false}
          loading={loading}
          columns={columns}
          dataSource={props.data?.approvals}
        />
        <div className="text-center mt-6">
          <Pagination
            onChange={(num) => {
              props.changePage(num);
              props.setAllPage(num);
            }}
            current={props.current}
            total={props.data?.totalCount || 0}
            pageSize={LIMIT_PER_PAGE}
          />
        </div>
      </>

      <ConfirmationModal
        visible={rejectModal}
        handleCancel={() => {
          setRejectModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to reject this?"
        title="Reject approval"
        handleOk={() => props.rejectApproval(approvalId, approvalAction, "all")}
      />
      <ConfirmationModal
        visible={approveModal}
        handleCancel={() => {
          setApproveModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to approve this?"
        title="Approve approval"
        handleOk={() =>
          props.approveApproval(approvalId, approvalAction, "all")
        }
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal(false);
          setUserInfo(false);
          setUnitInfo(false);
          setPlanInfo(false);
          setDesignationInfo(false);
          setApprovalId("");
        }}
        text="Are you sure want to delete this?"
        title="Delete approval"
        handleOk={() => {
          deleteApproval();
          props.changePage(props.current);
        }}
      />
      <ApproveUserModal
        visible={userInfo}
        handleCancel={() => {
          setUserInfo(false);
          setApprovalId("");
        }}
        data={data}
        handleOk={() => props.approveApproval(approvalId, "Approved", "all")}
        handleReject={() =>
          props.approveApproval(approvalId, "Rejected", "all")
        }
        handleDelete={() => setDeleteModal(true)}
      />
      <ApproveUnitModal
        visible={unitInfo}
        handleCancel={() => {
          setUnitInfo(false);
          setApprovalId("");
        }}
        data={data}
        handleOk={() => props.approveApproval(approvalId, "Approved", "all")}
        handleReject={() =>
          props.approveApproval(approvalId, "Rejected", "all")
        }
        handleDelete={() => setDeleteModal(true)}
      />
      <ApprovePlanModal
        visible={planInfo}
        handleCancel={() => {
          setPlanInfo(false);
          setApprovalId("");
        }}
        data={data}
        handleOk={() => props.approveApproval(approvalId, "Approved", "all")}
        handleReject={() =>
          props.approveApproval(approvalId, "Rejected", "all")
        }
        handleDelete={() => setDeleteModal(true)}
      />
      <ApproveDesignationModal
        visible={designationInfo}
        handleCancel={() => {
          setDesignationInfo(false);
          setApprovalId("");
        }}
        data={data}
        handleOk={() => props.approveApproval(approvalId, "Approved", "all")}
        handleReject={() =>
          props.approveApproval(approvalId, "Rejected", "all")
        }
        handleDelete={() => setDeleteModal(true)}
      />
      <EditApproverModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
          setApprovalId("");
          setCurrentApprover("");
        }}
        data={approvalId}
        currentApprover={currentApprover}
        handleOk={() => {
          props.changePage(props.current);
        }}
      />
    </>
  );
}

export default AllApprovalsTable;
